import { appConfig } from '../../../config/customization';

export default {
  checkedOk: {
    strokeWidth: 2.4,
    stroke: appConfig.colors.checkedOk,
    fill: 'none',
    marginRight: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  }
};
